import { createQueryClient, shouldRetry, getRetryDelay } from "@njbsoft/api-client";
import { ApiError } from "@njbsoft/api-client";
import { i18n } from "@njbsoft/i18n";
import { toast } from "sonner";

export { shouldRetry, getRetryDelay };

export const queryClient = createQueryClient({
  onError: (error: Error) => {
    if (error instanceof ApiError && error.status === 429) {
      // Resolved per toast, never hoisted: this module is evaluated before
      // `initI18n` runs, and the user can switch language afterwards, so a
      // module-scope lookup would freeze whatever language was current at boot.
      toast.error(i18n.t("errors.api.rate_limited"), {
        id: "rate-limit-toast",
        duration: 6000,
      });
    }
  },
});
